/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: events.Template.
export default class Template extends Model {
  declare [Type]: 'events/template';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from
  // the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // schoolId is the school the template is assigned to.
  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @alias('school.id')
  declare school_id: string | null | undefined;

  // label is the label to describe the template
  @attr('string', { defaultValue: '' })
  declare label: string;

  // content is the content within the template
  @attr('string', { defaultValue: '' })
  declare content: string;
}
